export function prettyJSON(data: unknown): string {
    // If it's a string, attempt to parse it as JSON.
    if (typeof data === 'string') {
        const raw = data;
        try {
            data = JSON.parse(data);
        } catch {
            return raw;
        }
    }

    if (data === null || typeof data === 'undefined') {
        return '';
    }

    if (typeof data === 'object') {
        try {
            return JSON.stringify(data, null, 2);
        } catch {
            return '[unserializable object]';
        }
    }

    switch (typeof data) {
        case 'string':
            return data;
        case 'number':
        case 'boolean':
        case 'bigint':
            return String(data);
        case 'symbol':
            return data.toString();
        case 'function':
            return '[function]';
        default:
            return '';
    }
}
